import { NoddiIcon, NoddiIconName } from 'noddi-ui-common';
import { ReactNode } from 'react';

export const InstructionRow = ({
  icon,
  title,
  description,
  subItems
}: {
  icon: NoddiIconName;
  title: string;
  description?: ReactNode;
  subItems?: string[];
}) => (
  <div className='flex items-start gap-2 md:gap-4'>
    <div className='mt-0.5 flex size-6 shrink-0 items-center justify-center rounded-md bg-grey/15'>
      <NoddiIcon name={icon} />
    </div>
    <div className='flex flex-col gap-1'>
      <p>{title}</p>
      {description && <p className='text-sm text-balance text-black/70'>{description}</p>}
      {subItems && subItems.length > 0 && (
        <div className='mt-1 flex flex-col gap-2 text-sm text-black/70'>
          {subItems.map((item, index) => (
            <p key={index} className='text-balance'>
              {item}
            </p>
          ))}
        </div>
      )}
    </div>
  </div>
);
